// Fonction pour formater les dates
export const formatDateForDisplay = (dateStr) => {
  const options = { weekday: 'short', day: 'numeric', month: 'short' };
  const date = new Date(dateStr);
  return date.toLocaleDateString('fr-FR', options);
};

// Fonction pour regrouper les dates par mois
export const groupDatesByMonth = (dates) => {
  const buckets = {};
  
  dates.forEach(dateStr => {
    const dt = new Date(dateStr);
    const y = dt.getFullYear();
    const m = dt.getMonth();
    const key = `${y}-${m}`;

    if (!buckets[key]) {
      buckets[key] = { year: y, month: m, dates: [] };
    }
    buckets[key].dates.push(dateStr);
  });

  return Object.values(buckets).map(({ year, month, dates }) => ({
    year,
    month,
    dates,
    monthLabel: new Date(year, month)
      .toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })
  }));
};